import React, { useEffect, useState } from "react";
import { requestPost, requestGet } from "utils/AxiosApi";
import { useNavigate } from "react-router-dom";
import RightMenu from "layout/RightMenu";
import InquiryModal from "modals/InquiryModal";
import Layout from "layout/Layout";
import RightSmallMenuBar from "layout/RightSmallMenuBar";
import Categroy from "layout/Category";
import { API_SERVER_URL } from "utils/config";

import { medmall_logo } from "utils/linkData";
import HeaderSearch from "./HeaderSearch";

const Main = () => {
  let history = useNavigate();
  const [showMenu, setShowMenu] = useState(false);

  const [selectedItem, setSelectedItem] = useState(0);
  const [selectedItemNm, setSelectedItemNm] = useState("액티브 그린멀티비타민");
  //모달창 open
  const [inquiryModalOpen, setInquiryModalOpen] = useState(false);

  const [buySite, setBuySite] = useState("");
  const [searchSite, setSearchSite] = useState("");

  const [img, setImg] = useState("");
  const [activeImg1, setActiveImg1] = useState("");
  const [activeImg2, setActiveImg2] = useState("");
  const [actionDetail, setActionDetail] = useState("");
  const [itemDetail, setItemDetail] = useState("");
  const [detailImg, setDetailImg] = useState<
    [{ fileNm: any; type: any }] | null
  >();
  const [contents, setContents] = useState("");

  const [title, setTitle] = useState("");
  const [price, setPrice] = useState(0);
  const [salePrice, setSalePrice] = useState(0);
  const [discountRate, setDiscountRate] = useState(0);
  const [kindNm, setKindNm] = useState("");

  const goodsDetailInfo = async () => {
    const current = decodeURI(window.location.href);
    const search = current.split("?")[1];
    const params = new URLSearchParams(search);
    let itemNum = params.get("itemNum");

    let data = await requestGet("/api/goods/info", {
      itemNum: itemNum,
    });
    let info = data.info;
    let titleTextArr = info.title.split("@");
    let titleText = titleTextArr[0];

    if (titleTextArr[1] !== undefined) {
      titleText = titleText + " " + titleTextArr[1];
    }

    setTitle(titleText);
    setSelectedItemNm(titleText);
    setBuySite(info.buyLink);
    setSearchSite(info.lowPriceLink);
    setItemDetail(info.activeDetail1);
    setActionDetail(info.activeDetail2);
    setSalePrice(info.salePrice);
    setPrice(info.price);
    setDiscountRate(info.discountRate);
    setKindNm(info.kindNm);

    let files = info.files.sort((a: any, b: any) => {
      return a.seq - b.seq;
    });

    setDetailImg(files);
    setImg(info.img);
    setActiveImg1(info.activeImg1);
    setActiveImg2(info.activeImg2);
  };

  const priceToString = (p: any) => {
    let price = p;

    let num: any = price;
    if (kindNm === "건강기능식품" || kindNm === "건강(기능)식품") {
      let calculation = price;
      num = calculation.toFixed();
    }
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  useEffect(() => {
    goodsDetailInfo();
  }, []);

  const goTop = () => {
    document.documentElement.scrollTop = 0;
  };

  const goBottom = () => {
    window.scrollTo(0, document.body.scrollHeight);
  };
  const onSearchGoods = () => {
    history("/goods?contents=" + contents);
  };
  return (
    <div>
      {title !== "" && (
        <Layout>
          <div id="main-div">
            <HeaderSearch
              medmall_logo={medmall_logo}
              contents={contents}
              setContents={setContents}
              onSearchGoods={onSearchGoods}
            ></HeaderSearch>
            <div className="div-left-search-m">
              <input placeholder="Search"></input>
              <img src="/svg/search.svg" alt="search" />
            </div>
            <div>
              <Categroy></Categroy>
            </div>

            <div className="display-center-margin-0">
              <div className="div-goods-detail-text-empty"></div>
              <div className="div-goods-detail">
                <div className="div-goods-detail-img">
                  <img
                    src={
                      API_SERVER_URL + "/api/goods/show?kind=I&filename=" + img
                    }
                    alt="img"
                    style={{ display: "inline" }}
                  ></img>
                </div>
                <div className="div-goods-detail-text">
                  <div className="div-goods-detail-text-title">
                    <span>{title}</span>
                  </div>
                  <div>
                    <img
                      className="img-goods-detail-img"
                      src={
                        API_SERVER_URL +
                        "/api/goods/show?kind=A&filename=" +
                        activeImg1
                      }
                      alt="img"
                      style={{ display: "inline" }}
                    ></img>

                    <img
                      className="img-goods-detail-img"
                      src={
                        API_SERVER_URL +
                        "/api/goods/show?kind=A&filename=" +
                        activeImg2
                      }
                      alt="img"
                      style={{ display: "inline" }}
                    ></img>
                  </div>
                  <div className="div-goods-detail-text-empty"></div>
                  {/* 소비자 가격 */}
                  <div className="div-goods-price-detail-2">
                    <span className="price-label">소비자가격</span>
                    <span className="discount-rate-empty"></span>
                    <span className="price">{priceToString(price)}</span>
                    <span className="price-unit">원/개</span>
                  </div>
                  {/* 최저제안가격 */}
                  <div className="div-goods-price-detail">
                    <span className="price-label">최저제안가격</span>
                    <span className="discount-rate">{discountRate}%</span>
                    <span className="price">{priceToString(salePrice)}</span>
                    <span className="price-unit">원/개</span>
                  </div>
                  <div>
                    <button
                      className="btn-buy"
                      id="font-SCD7"
                      onClick={() => window.open(buySite)}
                    >
                      구매하기
                    </button>
                    <div style={{ margin: "10px 0px" }}></div>
                    <button
                      onClick={() => window.open(searchSite)}
                      className="btn-search"
                      id="font-SCD7"
                    >
                      최저가확인
                    </button>
                  </div>
                </div>
              </div>
              <div style={{ clear: "both" }}></div>
              {/* 상품 */}
              <div className="div-goods-detail-text-empty1"></div>
              <div>
                <img
                  className="img-w100pc"
                  src={
                    API_SERVER_URL +
                    "/api/goods/show?kind=D&filename=" +
                    itemDetail
                  }
                  alt="item_discription"
                ></img>
              </div>
              {/* 상품상세설명1 */}
              {selectedItem < 5 ? (
                <div>
                  <img
                    className="img_active_detail"
                    src={
                      API_SERVER_URL +
                      "/api/goods/show?kind=D&filename=" +
                      actionDetail
                    }
                    alt="active_detail"
                  ></img>
                </div>
              ) : (
                <div style={{ textAlign: "center" }}>제품이 준비 중입니다.</div>
              )}
              {detailImg &&
                detailImg.map((img, index) => (
                  <div key={index}>
                    <img
                      style={{ width: "100%" }}
                      src={
                        img.type === "gif"
                          ? API_SERVER_URL +
                            "/api/goods/show?kind=G&filename=" +
                            img.fileNm
                          : API_SERVER_URL +
                            "/api/goods/show?kind=D&filename=" +
                            img.fileNm
                      }
                      alt="img-detail"
                    ></img>
                  </div>
                ))}
              <div style={{ textAlign: "center", margin: "30px 0px" }}>
                <button
                  className="btn-buy-bottom"
                  id="font-SCD7"
                  onClick={() => {
                    window.open(buySite);
                  }}
                >
                  구매하기
                </button>
              </div>
            </div>
            <RightMenu show={showMenu} setShowMenu={setShowMenu}></RightMenu>

            <RightSmallMenuBar
              selectedItemNm={selectedItemNm}
              goTop={goTop}
              goBottom={goBottom}
              buySite={buySite}
              searchSite={searchSite}
            ></RightSmallMenuBar>
          </div>

          <div style={{ clear: "both", marginBottom: "10px" }}></div>
          {/* <hr></hr> */}
        </Layout>
      )}
      {inquiryModalOpen && (
        <InquiryModal setOpenModal={setInquiryModalOpen}></InquiryModal>
      )}
    </div>
  );
};

export default Main;
